import { render, staticRenderFns } from "./SupportTicketReport.vue?vue&type=template&id=11475ed9&"
import script from "./SupportTicketReport.vue?vue&type=script&lang=js&"
export * from "./SupportTicketReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports